import { Component, Inject, OnInit } from '@angular/core';
import NiboWhatsAppConnection from '../../models/nibo-whatsapp-connection';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-connection-confirm-recreate',
  templateUrl: './connection-confirm-recreate.component.html',
  styleUrls: ['./connection-confirm-recreate.component.css']
})
export class ConnectionConfirmRecreateComponent implements OnInit {

   public updateData: { connection: NiboWhatsAppConnection };
 
   constructor(@Inject(MAT_DIALOG_DATA) public data: { connection: NiboWhatsAppConnection },
     public dialogRef: MatDialogRef<ConnectionConfirmRecreateComponent>) {
     this.updateData = data;
   }
 
   ngOnInit(): void {
   }
 
   public confirm() {
     this.dialogRef.close(true);
   }
 
   public cancel() {
     this.dialogRef.close(false);
   }

}
